import { Button, Checkbox, Col, Form, Input, Modal, Row, Select, Space, Typography } from 'antd'
import { defaultDate, defaultTime, formatDateTime, shortDateTime } from '../../util/dateTimeUtil'

import AppContext from '../common/AppContext'
import _ from 'lodash'
import { useContext } from 'react'
import { useEffect } from 'react'
import useResponsive from '../../hooks/useResponsive'
import { useWindowSize } from '../../hooks/useWindowSize'

const { Text, Paragraph, Title } = Typography

const BookingDeleteConfirmationModal = ({ booking, visible, onOk, onDeleteRecurring, onClose }) => {
  const { isRepeating } = booking ?? {}
  const { parent } = booking ?? {}

  // This is the parent of other repeating bookings.
  const isParent = !parent && isRepeating

  const defaultButtons = [
    <Button key="back" type="link" onClick={onClose}>
      Don't delete
    </Button>,
    <Button key="submit" type="primary" onClick={() => onOk(booking)} danger>
      Yes, delete
    </Button>,
  ]

  const recurringButtons = [
    <Button key="back" type="link" onClick={onClose}>
      Cancel
    </Button>,
    <Button key="submit" type="primary" onClick={() => onOk(booking)} disabled={isParent}>
      Delete this booking
    </Button>,
    <Button key="submit" type="primary" onClick={() => onDeleteRecurring(booking)} danger>
      Delete ALL related bookings
    </Button>,
  ]

  return (
    <Modal
      title={'Delete booking?'}
      onCancel={onClose}
      onClose={onClose}
      visible={visible}
      closable={true}
      maskClosable={true}
      keyboard={true}
      destroyOnClose={true}
      footer={isRepeating ? recurringButtons : defaultButtons}
    >
      {booking && isRepeating ? (
        isParent ? (
          <>
            <Paragraph>
              <b>NOTE:</b> This is the parent of other repeating bookings.
            </Paragraph>
            <Paragraph>
              You cannot choose to "Delete this booking" only because any related bookings would become orphans and
              would not be able to be deleted as a group in the future.
            </Paragraph>
          </>
        ) : (
          <Paragraph>
            This is a repeating booking. You can delete this specific booking, or this and all related repeating
            bookings.
          </Paragraph>
        )
      ) : (
        <Paragraph>
          Are you sure you want to delete the booking for <b>{formatDateTime(booking?.startTime, 'MMM d')}</b> at{' '}
          <b>{formatDateTime(booking?.startTime, 'h:mm a')}</b>?
        </Paragraph>
      )}
    </Modal>
  )
}

export default BookingDeleteConfirmationModal
